// @flow
import React from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import EstimateTemplate from 'components/estimate/EstimateTemplate';
import EstimateSections from 'containers/estimate/EstimateSections';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Estimate = ({ match }: Props) => {
  const { id } = match.params;
  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <EstimateTemplate>
        <Helmet>
          <title>견적서 요청 | 캐시바이</title>
        </Helmet>
        <EstimateSections id={id} />
      </EstimateTemplate>
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Estimate;



// WEBPACK FOOTER //
// ./src/pages/Estimate.js